<template>
  <section
    class="component-f84d9a52"
    resmed-component-name="info_30/70_icon-line_step-item_image_text_2cta"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-if="acf.headline">{{ acf.headline }}</h2>
          </div>
        </div>
        <div class="steps items">
          <div
            class="step item row align-items-center"
            v-for="item in acf.steps"
          >
            <div class="col-md-3 offset-md-1">
              <figure>
                <img class="img-fluid" v-bind:src="item.illustration" alt="" />
              </figure>
            </div>
            <div class="col-md-7">
              <div class="content mt-5 mt-md-0">
                <h5>{{ item.step }}</h5>
                <h3>{{ item.headline }}</h3>
                <div v-if="item.description" v-html="item.description"></div>

                <div class="call-to-action mt-3" v-if="item.cta.href">
                  <a
                    v-bind:href="item.cta.href"
                    v-bind:target="item.cta.target"
                    class="btn cta-pill filled-red icon right-arrow"
                    >{{ item.cta.text }}</a
                  >
                </div>

                <div
                  class="resources mt-3"
                  v-if="item['google-play'] || item['apple-app-store']"
                >
                  <a
                    v-if="acf['apple-app-store']"
                    target="_blank"
                    v-bind:href="acf['apple-app-store']"
                    class="btn apple-store d-inline-block text-hide"
                    >Download on the App Store</a
                  >
                  <a
                    v-if="acf['google-play']"
                    target="_blank"
                    v-bind:href="acf['google-play']"
                    class="btn google-play d-inline-block text-hide"
                    >Get it on Google Play</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-f84d9a52", // info_30/70_icon-line_step-item_image_text_2cta
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-f84d9a52 {
  padding: 5rem 0;

  @media (min-width: 992px) {
    padding: 6rem 0;
  }
}

.component {
  h2 {
    position: relative;
    margin: 0;
    text-align: center;

    @extend %eyebrow-center;
  }

  h3 {
    margin: 0 0 1.25rem 0;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 400;
  }

  h5 {
    position: relative;
    @extend %eyebrow-center;

    @media (min-width: 768px) {
      &:before {
        transform: none;
        left: 0;
      }
    }
  }

  .items {
    .item {
      text-align: center;
      margin-top: 4rem;
      margin-bottom: 3rem;
      padding-bottom: 3rem;
      border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.125);

      @media (min-width: 768px) {
        text-align: left;
      }

      &:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
      }

      figure {
        img {
          margin: 0 auto;
        }
      }
    }

    .resources {
      a {
        margin: 0 0.5rem;

        @media (min-width: 768px) {
          margin: 0;

          &:first-child {
            margin: 0 0.5rem 0 0;
          }
        }
      }
    }
  }
}
</style>